import Vue from 'vue'
import Vuex from 'vuex'
import 'babel-polyfill';

const LOGIN_SUCCESS          = "LOGIN_SUCCESS";
const LOGOUT                 = "LOGOUT";
const RESET_STORE            = 'RESET_STORE';
const SET_APP                = 'SET_APP';
const INITIALISE_STORE       = 'INITIALISE_STORE';
const AUTH_SUCCESS           = 'AUTH_SUCCESS';
const AUTH_FAIL              = 'AUTH_FAIL';
const SET_INTENDED_URL       = 'SET_INTENDED_URL';
const SET_USER               = 'SET_USER';
const SET_ACCOUNT            = 'SET_ACCOUNT';
const SET_ACCOUNTS           = 'SET_ACCOUNTS';
const SET_UNIT               = 'SET_UNIT';
const SET_CARD               = 'SET_CARD';
const SET_TICKET             = 'SET_TICKET';
const SET_REDEMPTION_AMOUNT  = 'SET_REDEMPTION_AMOUNT';
const SET_PIN_LOCKED         = 'SET_PIN_LOCKED';
const CHECK_ACCOUNT          = 'CHECK_ACCOUNT';
const INCREMENT_PIN_ATTEMPTS = 'INCREMENT_PIN_ATTEMPTS';
const RESET_PIN_ATTEMPTS     = 'RESET_PIN_ATTEMPTS';
const RESET_REDEEM_JOURNEY   = 'RESET_REDEEM_JOURNEY';
const ORDER_PAYLOAD          = 'ORDER_PAYLOAD';
const SET_CAMERA_ACTIVATED   = 'SET_CAMERA_ACTIVATED';
const TWOFACTOR_SENDSMS_REQUEST      = 'TWOFACTOR_SENDSMS_REQUEST';
const VALIDATE_TWOFACTOR             = 'VALIDATE_TWOFACTOR';
const TWOFACTOR_STATUS               = 'TWOFACTOR_STATUS';
const TWOFACTOR_ERROR                = 'TWOFACTOR_ERROR';
const SET_TWOFACTOR_MOBILE_NUMBER    = "SET_TWOFACTOR_MOBILE_NUMBER";
const SET_TWOFACTOR_JOURNEY_COMPLETE = "SET_TWOFACTOR_JOURNEY_COMPLETE";

Vue.use(Vuex);

function initialState () {
  return { 
	twofactor_complete: false,
	twofactor_mobile_number: '',
	twofactor_status: '',
	app:{
		version_increment            : false,
		refresh_local_cache_increment: false,
		api_version                  : false
	},
	isLoggedIn       : false,
	user_token       : '',
	accountId        : false,
	intendedURL      : false,
	user             : {},
	account          : false,
	accounts          : [],
	card             : {}, // currently processing card
	last_card             : {}, // last card to be processed
	redemption_amount: 0, // amount to redeem from card
	last_redemption_amount: 0, // last sucesfully redeemed amount
	pin_locked       : false,
	unit             : false,
	pin_attempts     : 0,
	order_payload    : {},
	camera_activated : false,
	ticket					 : {}
   }
}

export default new Vuex.Store({
	state: initialState(),
	mutations: {
		/**
		 * Set twofactor mobile number
		 */
		[SET_TWOFACTOR_MOBILE_NUMBER]: (state,mobile_number) => {
			state.twofactor_mobile_number = mobile_number
		},
		/**
		 * indicates whether the twofactor process has been completed successfully
		 */
		[SET_TWOFACTOR_JOURNEY_COMPLETE]: (state,is_complete) => {
			state.twofactor_complete = is_complete;
		},

		/**
		 * Send Code to SMS request state
		 * @return {state} defines SendSMS state as loading
		 */
		[TWOFACTOR_SENDSMS_REQUEST]: state => {
		state.twofactor_status = "loading";
		},

		/**
		 * Validate TwoFactor request state
		 * @return {state} defines TwoFA state as loading
		 */
		[VALIDATE_TWOFACTOR]: state => {
		state.twofactor_status = "loading";
		},

		/**
		 * TwoFactor success state
		 * @return {state} defines TwoFa state as success
		 */
		[TWOFACTOR_STATUS]: (state,twofactor_status) => {
		state.twofactor_status = twofactor_status;
		},

		/**
		 * TwoFactor error state
		 * @return {state} defines TwoFA state as error
		 */
		[TWOFACTOR_ERROR]: state => {
		state.twofactor_status = "error";
		},
			
		[RESET_STORE] (state) {
				// acquire initial state
				const s = initialState();
				Object.keys(s).forEach(key => {
				state[key] = s[key]
			})
		},

		
		/**
		* Removes all card/amount data from the store
		*/
		[RESET_REDEEM_JOURNEY] (state){
			const s                 = initialState();
			state.last_card = state.card; 
			state.last_redemption_amount = state.redemption_amount; 

			state.card              = s.card; 
			state.redemption_amount = s.redemption_amount; 
		},


		/**
		 * Resets the amounts of attempts pin has been tried to 0
		*/

		[RESET_PIN_ATTEMPTS](state){
			state.pin_attempts = 0;
		},

		/**
		* Increments the amount of times the pin has been tried
		*/
		[INCREMENT_PIN_ATTEMPTS](state){
			state.pin_attempts++;
		},

		/**
		* Locks the app with the pin screen
		* @type {bool} locked
		*/
		[SET_PIN_LOCKED] (state, value) {
			state.pin_locked = value;
		},

		/**
		* Add ab item to the basket
		* @type {object} basket item
		*/
		[SET_APP](state, value) {
			state.app = value;
		},

		/**
		* ASets the amoutn to redeem from a card
		* @type int
		*/
		[SET_REDEMPTION_AMOUNT](state, value) {
			state.redemption_amount = value;
		},


		/**
		* Set card in the redemption journey
		* @type {object} card 
		*/
		[SET_CARD](state, value) {
			state.card = value;
		},

		/**
		* Set ticket in the redemption journey
		* @type {object} ticket 
		*/
		[SET_TICKET](state, value) {
			state.ticket = value;
		},

		/**
		* Set user
		* @type {object} custom styles object
		*/
		[SET_USER](state, value) {
			state.user = value;
		},

		/**
		* Set unit
		* @type {object} custom styles object
		*/
		[SET_UNIT](state, value) {
			state.unit = value;
		},

		/**
		* Set account
		* @type {object} custom styles object
		*/
		[SET_ACCOUNT](state, value) {
			state.account = value;
		},

		/**
		* Set accounts
		* @type {object} custom styles object
		*/
		[SET_ACCOUNTS](state, value) {
			state.accounts = value;
		},

		/**
		 * Order payload
		 * @type {object} custom styles object
		 */
		[ORDER_PAYLOAD](state, value) {
			state.order_payload = value;
		},

		/**
		* Initialises the store to the last state saved in local storage
		*/
		[INITIALISE_STORE](state) {
			// Check if the ID exists
			if(localStorage.getItem('store')) {
				// Replace the state object with the stored item
				var newState = JSON.parse(localStorage.getItem('store'));

				const s = initialState()
				newState.loading		= s.loading;

				this.replaceState(
					Object.assign(state, newState)
				);
			}
		},



		[AUTH_SUCCESS]: (state, token) => {
			state.user_token = token;
		},


		[AUTH_FAIL]: (state) => {
			state.user_token = '';
		},

		/**
		* Set login success vars
		*/
		[LOGIN_SUCCESS] (state) {
			state.isLoggedIn = true;
		},

		/**
		* Set logout vars
		*/
		[LOGOUT](state) {
			state.accountId  = false;
			state.isLoggedIn = false;
			state.user_token = '';
		},

		/**
		* Set URL to visit after succesfull login
		* @type {string} url
		*/
		[SET_INTENDED_URL](state, url) {
			state.intendedURL = url;
		},

		// checks that if there is an account/unit set in the storage, that the logged in user has access to it
		[CHECK_ACCOUNT](state){
			if(state.account.id !== undefined && state.user && state.user.Accounts.length){
				let found = state.user.Accounts.find(o => o.id === state.account.id );
				if(!found){
					state.account = false;
					state.unit = false;
				}
			}
		},
		[SET_CAMERA_ACTIVATED](state,status) {
			state.camera_activated = status;
		}
 

	},
	actions: {
		/**
		* Sends the code to the user mobile number that should be verified
		* @return {Promise} returns error or success from API request
		*/
		[TWOFACTOR_SENDSMS_REQUEST]: ({ commit }) => {
			return new Promise((resolve, reject) => {
				commit(TWOFACTOR_SENDSMS_REQUEST);
				window.axios({
				url: process.env.VUE_APP_API_GRAPH_URL,
				method: 'post',
				data: [
					{
						query: `
							mutation{
								generateTwofactorCode 
							}
							` 
					}
				]
				}).then(() => {
					commit(TWOFACTOR_STATUS,'success');
					resolve('success');
				}).catch((error)=>{
					commit(TWOFACTOR_ERROR);
					reject(error);
				})
			});
		},

		/**
		 * Validates TwoFactor code sent from user
		 * @param  {Object|string} [usercode={usercode}] code sent from user to verify two factor
		 * @return {Promise} returns error or success from API request
		 */
		[VALIDATE_TWOFACTOR]: ({ commit }, usercode) => {
			return new Promise((resolve, reject) => {
				commit(VALIDATE_TWOFACTOR);
				window.axios({
				url: process.env.VUE_APP_API_GRAPH_URL,
				method: 'post',
				data: [
					{
						query: `
							mutation(
								$code  : String!,
								$remember_me  : Boolean!
							){
								verifyTwofactorCode(
									code: $code,
									remember_me : $remember_me
								) 
							}
							` ,
						variables:{
							code: usercode.usercode,
							remember_me:usercode.remember_me
						}
					}
				]
				}).then((resp) => {
				if (resp.data[0].data.verifyTwofactorCode === "1") {
					commit(TWOFACTOR_STATUS,'success');
					resolve('success');
				} else {
					commit(TWOFACTOR_ERROR);
					reject(401);
				}
				}).catch((error)=>{
				commit(TWOFACTOR_ERROR);
				reject(error);
				})
			});
			},
		
		/*
		* Commits user token
		*/
		refreshUserToken({commit}, token){
			commit(AUTH_SUCCESS,token); 
			commit(LOGIN_SUCCESS);
		},

		/*
		* Updates the configuration in the store
		*/
		updateConfig({commit})
      {
		return new Promise((resolve,reject) => {

			window.axios({
				url: process.env.VUE_APP_API_GRAPH_URL,
				method: 'post',
				data: {
				query: `
					query($linked:Boolean!,$product_active:Int, $store_type_id:Int, $show_in_pos:Boolean, $restrict_pos_units:Boolean){
						Accounts(linked:$linked){
						id,
						name,
						auto_generate_card_references,
						Units(restrict_pos_units:$restrict_pos_units){
							id,name
						},
						show_sell_gift_card_pos,
						Features(limit:100,page:1){
							data {id}
						},
						Products(active:$product_active, store_type_id:$store_type_id, show_in_pos:$show_in_pos){
							id, 
							name, 
							slug, 
							short_description, 
							long_description, 
							active, 
							stock_available,
							sale_limit,
							display_remaining_at,
                            allow_custom_price_modifier,
                            webshop_min_custom_value,
                            webshop_max_custom_value,
							CurrentExpiryConfig{
							seconds_valid_for
							}, 
							ProductType{
							id,
							name
							}, 
							FulfilmentMethods{
							id,
							name
							}, 
							PriceModifiers{
							id, 
							price, 
							description, 
							Currency{
								id, 
								denomination, 
								symbol
							}
							}
						},
						Currency {
                            iso_currency_code,
                            denomination, 
														symbol
                        }
						}
					}
					`,
					variables: {
						linked: true,
						product_active:1,
						store_type_id:1,
						show_in_pos:true,
						restrict_pos_units:true
					}
				}
			}).then((result) => {

				if(result.data.data && result.data.data.Accounts && result.data.data.Accounts.length) {

					commit('SET_ACCOUNTS',result.data.data.Accounts); 

					// update stored selected account and unit to the new versions
					let account  = result.data.data.Accounts.find(o => o.id === this.getters.getAccount.id ); // get updated version of currently selecteda ccount
					if(account) {
						commit('SET_ACCOUNT',account); 
						if(this.getters.getUnit){
							let unit = account.Units.find(o => o.id === this.getters.getUnit.id );  // get updated version of currently selected unit
							commit('SET_UNIT', (unit ? unit : false));
						}
					}else{
						commit('SET_ACCOUNT',false); 
						commit('SET_UNIT',false); 
					}

				}

				// no accounts, so deselect currently selected account and unit
				if(!result.data.data.Accounts.length){ 
					commit('SET_ACCOUNT',false); 
					commit('SET_UNIT',false); 
					reject('User is not assigned to any accounts.');
				}

				resolve(result);

			}).catch(() => reject('Something has gone wrong.'));

		});
      },

		login({ commit }, vars) {
			window.axios({
				url: process.env.VUE_APP_API_GRAPH_URL,
				method: 'post',
				data: {
					query: `
						query($email:String!, $password:String!,$remember_token:String){
							loginUser(email:$email,password:$password,remember_token:$remember_token) {
								id,
								name,
								twofactor_enabled,
							    twofactor_mobile_number,
								disable_twofactor,
								Permissions {
            						id,
            						name
        						}
								Accounts{
									id
								}
							}
						}
					  `,
					variables:{
						email:vars.email,
						password:vars.password,
						remember_token:vars.remember_token
					}
				}
			}).then((result) => {
				if(result.data.data && result.data.data.loginUser){
					commit('SET_USER', result.data.data.loginUser);
					commit('CHECK_ACCOUNT');
					commit('RESET_PIN_ATTEMPTS');
					commit('SET_TWOFACTOR_MOBILE_NUMBER',result.data.data.loginUser.twofactor_mobile_number);
					vars.success_callback(result.data.data.loginUser.twofactor_enabled,result.data.data.loginUser.disable_twofactor);
				}
				else{
					if(vars.error_callback !== undefined)
						vars.error_callback(result);
				}
			});
		},

		logout({ commit }) {
			commit(LOGOUT);
			window.location.href = '/';
		}
	},
	getters: {

		getUserToken: state => {
			return state.user_token
		},

		getUser: state => {
			return state.user
		},

		getCard: state => {
			return state.card
		},

		getTicket: state => {
			return state.ticket
		},

		getLastCard: state => {
			return state.last_card
		},

		getLastRedemptionAmount: state => {
			return state.last_redemption_amount
		},

		getLoggedIn: state => {
			return state.isLoggedIn
		},

		getApp: (state) => {
			return state.app;
		},

		getIntendedUrl: state => {
			return state.intendedURL
		},

		getPinLocked: state => {
			return state.pin_locked
		},

		getRedemptionAmount: state => {
			return state.redemption_amount
		},

		getAccount: state => {
			return state.account
		},

		getAccounts: state => {
			return state.accounts
		},

		getUnit: state => {
			return state.unit
		},

		getAccountCurrency: state => {
			return state.account.Currency
		},

		getProducts: state => {
			return state.account.Products
        },

		getPinAttempts: state => {
			return state.pin_attempts
		},

		getOrderPayload: state => {
			return state.order_payload
		},
		getCameraActivated: state => {
			return state.camera_activated;
		},
		getTwofactorMobileNumber: (state) => {
			return state.twofactor_mobile_number;
		},
		getTwofactorJourneyStatus: state => state.twofactor_status,
		getTwofactorComplete: state => state.twofactor_complete,

        getAccountId: (state) => {
            return state.account.id;
        },
		getUserPermissions: (state) => {
			return state.user.Permissions;
		}
	}
	
})